import { CalendarCheck, Chat, Respect, ShieldCheck } from '@insify/design-system/line-icons';
import { SectionHeader, Shop } from '@insify/funnel-components';
import { useTranslation } from 'react-i18next';

import { useConditionsQuery } from '../../../../hooks/useQueries';

export const USP = (): JSX.Element => {
  const { t } = useTranslation();
  const { dailyCancellable = true } = useConditionsQuery()?.data?.professionalLiability ?? {};

  const items = [
    {
      Icon: ShieldCheck,
      text: t('funnel:coverage_usp_1'),
    },
    {
      Icon: Respect,
      text: t('funnel:coverage_usp_2'),
    },
    {
      Icon: Chat,
      text: t('funnel:coverage_usp_3'),
    },
    ...(dailyCancellable ? [{ Icon: CalendarCheck, text: t('funnel:coverage_usp_4') }] : []),
  ];

  return (
    <>
      <SectionHeader>
        <SectionHeader.Heading>{t('funnel:coverage_usp_why_insify')}</SectionHeader.Heading>
      </SectionHeader>
      <Shop.USPGrid items={items} />
    </>
  );
};
